import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ContainerService } from '../../core/services/container.service';
import { ContainerFormBaseComponent } from '../container-form-base.component';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule, NgIf } from '@angular/common';
import { ContainerType } from '../../core/models/container-type.model';
import { ContainerTypeService } from '../../core/services/container-type.service';
import { Client } from '../../core/models/client.model';
import { ClientService } from '../../core/services/client.service';
import { ContainerOwnerService } from '../../core/services/container-owner.service';

@Component({
  selector: 'app-container-create',
  templateUrl: './container-create.component.html',
  styleUrls: ['./container-create.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule, NgIf],
})
export class ContainerCreateComponent extends ContainerFormBaseComponent implements OnInit {
  containerTypes: ContainerType[] = [];
  clients: Client[] = [];
  containerOwners: any[] = [];


  constructor(
    protected override fb: FormBuilder,
    private containerService: ContainerService,
    private containerTypeService: ContainerTypeService,
    private clientService: ClientService,
    private router: Router,
    private containerOwnerService: ContainerOwnerService
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.loadContainerTypes();
    this.loadClients();
    this.loadContainerOwners()
  }

  onSubmit(): void {
    if (this.containerForm.valid) {
      const newContainer = this.containerForm.value;
      this.containerService.createContainer(newContainer).subscribe({
        next: response => {
          console.log('Envase creado:', response);
          this.router.navigate(['/containers']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al crear el envase:', error.message);
          this.errorMessage = error.error || 'Ocurrió un error al crear el envase';
        },
        complete: () => {
          console.log('Solicitud de creación de contenedor completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
      this.errorMessage = 'Por favor, complete todos los campos obligatorios.';
    }
  }

  loadContainerTypes(): void {
    this.containerTypeService.getContainerTypes().subscribe({
      next: containerTypes => {
        this.containerTypes = containerTypes;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los tipos de envases:', error.message);
        this.errorMessage =
          error.error.message || 'Ocurrió un error al cargar los tipos de envases';
      },
    });
  }

  loadClients(): void {
    this.clientService.getClients().subscribe({
      next: clients => {
        this.clients = clients;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los clientes:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los clientes';
      },
    });
  }

  loadContainerOwners(): void {
    this.containerOwnerService.getContainerOwners().subscribe({
      next: response => {
        this.containerOwners = response
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los propietarios de contenedores:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los propietarios de contenedores';
      },
    });
  }

}
